document.addEventListener("click", (e) => {
  const caret = e.target.closest(".menu-toggle-caret");
  if (!caret) return;

  // Toggle nur wenn wirklich auf Caret geklickt wurde
  e.preventDefault();
  e.stopPropagation();

  const summary = caret.closest("summary");
  if (!summary) return;

  summary.click(); // nutzt Dawn-Mechanik => Submenu wird korrekt sichtbar
});

// Link soll NICHT togglen (weil summary pointer-events:none, aber extra sicher)
document.addEventListener("click", (e) => {
  const link = e.target.closest(".header__menu-link, .menu-drawer__menu-link");
  if (!link) return;
  e.stopPropagation();
});
